import { Injectable } from '@angular/core';
import { CommonDialogFactoryService } from '@CaseOne/Common/dialog-factory/services/dialog-factory.service';
import { AppSaveChangesActiveListener } from '@CaseOne/App/src/app-save-changes/app-save-changes.types';
import {
	ICommonDialogFactoryOptions
} from '@CaseOne/Common/dialog-factory/interfaces/dialog-factory-options.interface';
import { CommonPopup } from '@CaseOne/Common/popup/popup';
import { extend } from 'lodash';
import { CommonBaseService } from '@CaseOne/Common/common-base-service.class/common-base-service.class';


@Injectable({
	providedIn: 'root'
})
export class AppSaveChangesService extends CommonBaseService {
	private dialogFactory = this.injector.get(CommonDialogFactoryService);

	private activeListener: AppSaveChangesActiveListener;

	showConfirmationDialog (popupConfig: Partial<ICommonDialogFactoryOptions>): CommonPopup {
		const config = extend({
			header: this.instant('common.save_changes_dialog.header'),
			declineText:  this.instant('common.save_changes_dialog.decline_text'),
			closeText:  this.instant('common.save_changes_dialog.close_text'),
			acceptText:  this.instant('common.save_changes_dialog.accept_text.save'),
		}, popupConfig);

		return this.dialogFactory.create(config);
	}

	callTrusted (callback: () => any) {
		!this.activeListener ? callback() : this.activeListener(callback);
	}

	toggleActiveListener (listener: AppSaveChangesActiveListener) {
		this.activeListener = listener;
	}
}
